import React, { useEffect } from "react";
import "./LegalPage.css";
import { Typography, Divider } from "antd";

const { Title, Text, Paragraph } = Typography;

function LegalPage({ content }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [content]);

  if (!content) return null;

  return (
    <div className="legalPage">
      <div className="legalPage__container">
        <Title level={1} className="legalPage__title">
          {content.title}
        </Title>
        <Text type="secondary" className="legalPage__date">
          {content.lastUpdated}
        </Text>
        
        <Divider />

        <div className="legalPage__content">
          {content.sections.map((section, index) => (
            <div key={index} className="legalPage__section">
              <Title level={4} className="legalPage__sectionTitle">
                {section.heading}
              </Title>
              <Paragraph className="legalPage__sectionText">
                {section.text}
              </Paragraph>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LegalPage;
